import React from 'react';
import { makeStyles, useTheme } from '@material-ui/core';
import { SparrowMark } from './SparrowMark';

/**
 * Full sidebar logo lockup: brand mark + "Sparrow Launchpad" wordmark.
 *
 * Theme-aware: the sidebar is a white surface in light mode and a near-black
 * panel in dark mode, so the wordmark uses the theme text color with the
 * "Launchpad" half tinted teal (matching the Twigs design spec).
 */
const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  wordmark: {
    fontSize: '0.9375rem',
    fontWeight: 800,
    letterSpacing: '-0.01em',
    color: theme.palette.text.primary,
    lineHeight: 1.1,
    whiteSpace: 'nowrap',
  },
  accent: {
    color: theme.palette.primary.main,
  },
}));

const LogoFull = () => {
  const classes = useStyles();
  const theme = useTheme();

  return (
    <div className={classes.root}>
      <SparrowMark size={26} color={theme.palette.primary.main} />
      <div className={classes.wordmark}>
        Sparrow <span className={classes.accent}>Launchpad</span>
      </div>
    </div>
  );
};

export default LogoFull;
